import { Link } from 'react-router-dom';
import PayLaterMessage from './PayLaterMessage';
import {
    SiPaypal,
    SiApplepay,
    SiGooglepay,
    SiVisa,
    SiAmericanexpress,
} from 'react-icons/si';

// Mastercard's mark in its real colours (the icon libraries only ship a
// single-colour version): red and yellow circles with an orange overlap.
const MastercardMark = ({ size = 40 }) => (
    <svg width={size} height={size * 0.62} viewBox="0 0 131.39 81.5" aria-hidden="true" focusable="false">
        <circle cx="40.7" cy="40.75" r="40.7" fill="#EB001B" />
        <circle cx="90.69" cy="40.75" r="40.7" fill="#F79E1B" />
        <path d="M65.7 8.6a40.66 40.66 0 0 1 0 64.3 40.66 40.66 0 0 1 0-64.3z" fill="#FF5F00" />
    </svg>
);

// Official brand marks (Simple Icons, via react-icons), shown unaltered in each
// brand's colours as payment-acceptance marks. Klarna and Clearpay use their
// wordmark-on-brand-colour badge style (the libraries only carry Klarna's "K."
// symbol and nothing for Clearpay) — swap in the official badge artwork from
// their merchant kits if you have it.
const METHODS = [
    { name: 'Klarna', label: 'Klarna.', className: 'rd-pay-pill--klarna' },
    { name: 'Clearpay', label: 'clearpay', className: 'rd-pay-pill--clearpay' },
    { name: 'PayPal', Icon: SiPaypal, size: 22, text: 'PayPal', className: 'rd-pay-pill--paypal' },
    { name: 'Apple Pay', Icon: SiApplepay, size: 46, className: 'rd-pay-pill--apple' },
    { name: 'Google Pay', Icon: SiGooglepay, size: 48, className: 'rd-pay-pill--google' },
    { name: 'Visa', Icon: SiVisa, size: 48, className: 'rd-pay-pill--visa' },
    { name: 'Mastercard', Icon: MastercardMark, size: 42, className: 'rd-pay-pill--mc' },
    { name: 'American Express', Icon: SiAmericanexpress, size: 38, className: 'rd-pay-pill--amex' },
];

const PaymentMethodsBand = () => (
    <section className="rd-pay-band" aria-labelledby="rd-pay-heading">
        <div className="rd-pay-band__copy">
            <span className="rd-pay-band__eyebrow">Pay your way</span>
            <h2 id="rd-pay-heading" className="rd-pay-band__title">
                Shop now, pay later, <span>interest-free</span>
            </h2>
            <p className="rd-pay-band__text">
                Split your order into <strong>3 payments with Klarna</strong> or <strong>4 with Clearpay</strong>.
                Prefer to pay in full? Use your card, PayPal, Apple Pay or Google Pay. Every payment is
                secured by Stripe.
            </p>
            {/* Stripe's official Klarna/Clearpay message with its "See plans" pop-up (example £60 basket) */}
            <div className="rd-pay-band__messaging">
                <PayLaterMessage price={60} />
            </div>
            <Link to="/help#pay-later" className="rd-pay-band__link">How paying later works &rarr;</Link>
        </div>
        <ul className="rd-pay-band__methods" aria-label="Payment methods we accept">
            {METHODS.map(({ name, Icon, size, label, text, className }) => (
                <li key={name} className={`rd-pay-pill ${className}`} aria-label={name} title={name}>
                    {Icon ? <Icon size={size} aria-hidden="true" focusable="false" /> : <span aria-hidden="true">{label}</span>}
                    {text && <span className="rd-pay-pill__text" aria-hidden="true">{text}</span>}
                </li>
            ))}
        </ul>
    </section>
);

export default PaymentMethodsBand;
